import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { Alert, Button } from 'reactstrap';
import { withCookies } from 'react-cookie';
import classNames from 'classnames'; // Please use the correct export for this component in order to utilize cookies.
// ex: import Notification from "<library>"
// Alert.stories.js specifies the import to escape the cookie storage for UX purposes.

export var Notification = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Notification, _React$Component);

  function Notification(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "dismiss", function () {
      var _this$props = _this.props,
          cookies = _this$props.cookies,
          cookieName = _this$props.cookieName;

      if (cookies && cookieName) {
        cookies.set(cookieName, true, {
          path: '/'
        });
      }

      _this.toggle();
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.setState({
        closed: !_this.state.closed
      });
    });

    var _cookies = props.cookies,
        _cookieName = props.cookieName;
    _this.state = {
      closed: _cookies && _cookieName ? _cookies.get(_cookieName) : false
    };
    return _this;
  }

  var _proto = Notification.prototype;

  _proto.render = function render() {
    var _classNames;

    var alertClass = classNames('notification fixed-bottom mb-0 border-0 p-0', (_classNames = {}, _classNames["" + this.props.className] = this.props.className, _classNames['notification--floating'] = this.props.floating, _classNames['notification--closed'] = this.state.closed, _classNames));
    return /*#__PURE__*/React.createElement(Alert, {
      color: this.props.color,
      className: alertClass
    }, /*#__PURE__*/React.createElement("div", {
      className: "notification__container d-flex px-3 py-2 justify-content-center align-items-center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "notification__text"
    }, this.props.text), this.props.buttonText ? /*#__PURE__*/React.createElement(Button, {
      color: this.props.buttonColor,
      onClick: this.dismiss,
      className: "notification__btn ml-3 position-relative " + this.props.buttonClass
    }, this.props.buttonText) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: this.dismiss,
      className: "notification__btn notification__btn--close close position-absolute",
      "aria-label": "Close"
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")), this.props.link && /*#__PURE__*/React.createElement("span", {
      className: "notification__link position-absolute w-100 h-100"
    }, this.props.link)));
  };

  return Notification;
}(React.Component);
export default withCookies(Notification);
Notification.defaultProps = {
  color: 'Primary',
  text: 'This website uses cookies to ensure you get the best experience on our website.',
  buttonColor: 'Primary',
  floating: false,
  cookieName: 'GDPR'
};